import { Component } from '@angular/core';
import { HttpService } from '../../http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../../global.service';
import { ConstituencyService } from '../../constituency/constituency.service';

@Component({
  selector: 'app-constituency-register',
  templateUrl: './constituency-register.component.html',
  styleUrls: ['./constituency-register.component.scss']
})
export class ConstituencyRegisterComponent {
  constituency_register_form: FormGroup;
  action: 'register' | 'update' = null;

  constructor(private http: HttpService, private formBuilder: FormBuilder, private global: GlobalService, private constituencyService: ConstituencyService) {
    this.constituency_register_form = formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])]
    });

    // one time data get
    if (this.constituencyService.get_constituency_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.constituencyService.get_constituency_data);
    }

    // watch table add or edit button clicked
    this.constituencyService.constituencyUpdate.subscribe((constituency) => {
      if (constituency === null) {
        this.action = 'register';
        this.constituency_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(constituency);
      }
    });
  }

  registerConstituency() {
    this.http.registerConstituency(this.constituency_register_form.value).subscribe((data) => {
      console.log(data);
      this.constituency_register_form.reset();
      this.global.showSnakeBar(data['message']);
      this.constituencyService.downloadConstituency.emit(true);
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(constituency) {
    this.constituency_register_form.controls['id'].setValue(constituency['id']);
    this.constituency_register_form.controls['name'].setValue(constituency['name']);
  }
}
